import { render, staticRenderFns } from "./Cultural-relics.vue?vue&type=template&id=3a6ee474&scoped=true"
import script from "./Cultural-relics.vue?vue&type=script&lang=js"
export * from "./Cultural-relics.vue?vue&type=script&lang=js"
import style0 from "./Cultural-relics.vue?vue&type=style&index=0&id=3a6ee474&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ee474",
  null
  
)

export default component.exports